import { render, staticRenderFns } from "./peservation.vue?vue&type=template&id=fec02cf8&scoped=true"
import script from "./peservation.vue?vue&type=script&lang=js"
export * from "./peservation.vue?vue&type=script&lang=js"
import style0 from "./peservation.vue?vue&type=style&index=0&id=fec02cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec02cf8",
  null
  
)

export default component.exports